import Group from '@pinecast/common/Group';
import type {CSS} from '@pinecast/styles';
import type * as React from 'react';

import type {StatusMessageProps} from './StatusMessage';
import StatusMessage from './StatusMessage';

type Props = Omit<StatusMessageProps, 'visuallyHidden'> & {
  children: React.ReactNode;
  position?: 'left' | 'right';
  style?: CSS;
};

/**
 * A status message beside a button: "Saved", or why saving failed. See
 * `StatusMessage` for how a screen reader gets the message.
 */
const ButtonLabel = ({
  children,
  message,
  pendingMessage,
  position = 'right',
  style,
  type,
}: Props) => (
  <Group spacing={8} centerChildren wrapperStyle={style}>
    {position === 'right' && <>{children}</>}
    <StatusMessage
      message={message}
      pendingMessage={pendingMessage}
      type={type}
    />
    {position === 'left' && <>{children}</>}
  </Group>
);

export default ButtonLabel;
